export const routeNames = Object.freeze({
  MAP_FISH: 'fish-map',
  FISH_ZERO_QUERY_SEARCH: 'fish-zero-query-search',
  FISH_QUICK_SEARCH: 'fish-quick-search',
  PHOTO_VIEWER: 'photo-viewer',
})
